import axios from 'axios'
import Cookies from "js-cookie";
import sha256 from "crypto-js/sha256";
import randomBytes from "randombytes";

import {
    SET_IDENTITY,
    SET_TOKEN,
    SET_GUARD_OUTLET_ID,
    SET_GUARD_PASS,
    SET_GUARD_TYPE_ID,
    SET_WHITE_LABEL,
    SET_SHOW_MADE_VIA_DIGARSON,
    SET_GUARD_ADDRESS_ENABLED,
    SET_GTM_TAG,
    SET_NOT_WORKING,
    SET_GUARD_CITIES,
    SET_GUARD_TYPES,
    SET_GUARD_OUTLETS,
    SET_GUARD_AREAS,
    SET_GUARD_CITY_ID,
    SET_GUARD_AREA_ID,
    SET_GUARD_AREA_TYPE_ID,
    SET_SHOW_CHOOSE_OUTLETS_ALWAYS,
    SET_CSS_DIRECTION,
    SET_GUARD_MODE,
    SET_GUARD_MODE_INITIAL,
    SET_CHECK_IOS,
    SET_SHOP_MODE,
    SET_NOT_ACCESS,
    SET_COMPANY_NAME
} from "@/store/mutations.type";

import {
    DISABLE_OVERLAY,
    GUARD_DISABLE,
    GUARD_CHECK_IIKO
} from '@/store/actions.type'

const DEFAULT = 'Default'
const ECOMMERCE = 'ECommerce'

export default {
    WEBVIEW_MODE: null,
    css_direction: '',
    outlet: null,
    responseConfig: null,
    check_iiko: null,

    router: null, // Сначала в main.js вызывается initRouter,
    // только после этого можем в любых файлах
    // импортить loader и обращаться к loader.router

    store: null, // Сначала в main.js вызывается initStore,
    // только после этого можем в любых файлах
    // импортить loader и обращаться к loader.store

    const: {
        DEFAULT,
        ECOMMERCE
    },

    component(path, mode = null) {
        mode = mode ? mode : this.WEBVIEW_MODE
        return 'components/' + mode + '/' + path + '.vue'
    },

    view(path, mode = null) {
        mode = mode ? mode : this.WEBVIEW_MODE
        return 'views/' + mode + '/' + path + '.vue'
    },

    async initRouter(mode = null) {
        mode = mode ? mode : this.WEBVIEW_MODE
        const router = await
        import (`@/router/${mode}/router.js`)
        this.router = router.default
        return router.default
    },

    async initAxios() {
        const _this = this
        axios.interceptors.request.use(function(config) {
            config.headers.identity = _this.store.getters.identity
            config.headers.clientInfo = _this.store.getters.clientInfo
            config.headers.guardPass = _this.store.getters.guardPass || ''
            config.headers.queryParams = _this.store.getters.queryParams
            return config
        })
    },

    async getIdentity() {
        let cookie = Cookies.get("identity");
        if (!cookie && token) {
            cookie = sha256(token + randomBytes(64) + Date.now()).toString();
            Cookies.set("identity", cookie, { expires: 365 });
        }
        return cookie
    },

    async initStore(mode = null) {
        mode = mode ? mode : this.WEBVIEW_MODE
        const store = await
        import (`@/store/${mode}/index.js`)
        this.store = store.default
        return store.default
    },

    async fillStore() {
        await this.store.commit(SET_TOKEN, token)

        if (this.check_iiko) {
            await this.store.dispatch(GUARD_CHECK_IIKO, this.check_iiko)
        }
        await this.store.commit(SET_CSS_DIRECTION, this.css_direction)

        let cookie = await this.getIdentity();
        await this.store.commit(SET_IDENTITY, cookie);

        if (this.outlet) {
            await this.store.commit(SET_GUARD_TYPE_ID, this.outlet.type_id);
            await this.store.commit(SET_GUARD_OUTLET_ID, this.outlet.outlet_id);
            await this.store.commit(SET_GUARD_PASS, this.outlet.identifier);
        }

        if (this.responseConfig.show_choose_outlets_always) {
            await this.store.commit(SET_SHOW_CHOOSE_OUTLETS_ALWAYS, this.responseConfig.show_choose_outlets_always)
        }

        if (this.responseConfig) {
            // guard init
            this.store.commit(SET_SHOW_MADE_VIA_DIGARSON, !this.responseConfig.is_prototype)
            this.store.commit(SET_GUARD_ADDRESS_ENABLED, this.responseConfig.address_input_enabled)
            this.store.commit(SET_GTM_TAG, this.responseConfig.gtmTag)
            this.store.commit(SET_NOT_WORKING, this.responseConfig.notWorking)
            this.store.commit(SET_NOT_ACCESS, this.responseConfig.notAccess)
            if (this.responseConfig.companyName) {
                document.title = this.responseConfig.companyName
                this.store.commit(SET_COMPANY_NAME, this.responseConfig.companyName)
            }

            if (this.responseConfig.cities) {
                this.store.commit(SET_GUARD_CITIES, this.responseConfig.cities)
            }
            if (this.responseConfig.types) {
                if (this.responseConfig.type_id) {
                    const filteredTypes = this.responseConfig.types.filter(type => type.id === this.responseConfig.type_id)
                    this.store.commit(SET_GUARD_TYPES, filteredTypes)
                } else {
                    this.store.commit(SET_GUARD_TYPES, this.responseConfig.types)
                }
            }
            if (this.responseConfig.outlets) {
                if (this.responseConfig.type_id) {
                    const filteredOutlets = this.responseConfig.outlets.filter(type => type.type_id === this.responseConfig.type_id)
                    this.store.commit(SET_GUARD_OUTLETS, filteredOutlets)
                } else {
                    this.store.commit(SET_GUARD_OUTLETS, this.responseConfig.outlets)
                }
            }
            if (this.responseConfig.areas) {
                this.store.commit(SET_GUARD_AREAS, this.responseConfig.areas)
            }
            if (this.responseConfig.city_id) {
                this.store.commit(SET_GUARD_CITY_ID, this.responseConfig.city_id)
            }
            if (this.responseConfig.type_id) {
                this.store.commit(SET_GUARD_TYPE_ID, this.responseConfig.type_id)
            }
            if (this.responseConfig.outlet_id) {
                this.store.commit(SET_GUARD_OUTLET_ID, this.responseConfig.outlet_id)
            }
            if (this.responseConfig.area_id) {
                this.store.commit(SET_GUARD_AREA_ID, this.responseConfig.area_id)
            }
            if (this.responseConfig.area_type_id) {
                this.store.commit(SET_GUARD_AREA_TYPE_ID, this.responseConfig.area_type_id)
            }

            await this.store.commit(SET_GUARD_MODE, this.responseConfig.initial_mode)
            this.store.commit(SET_GUARD_MODE_INITIAL, this.responseConfig.initial_mode)

            if (this.responseConfig.identifier && !this.outlet) {
                await this.store.commit(SET_GUARD_PASS, this.responseConfig.identifier)
                if (this.store.getters.guardMode === this.store.getters.guardModes.GUARD_MODE_SKIP) {
                    await this.store.dispatch(GUARD_DISABLE)
                } else {
                    await this.store.dispatch(DISABLE_OVERLAY)
                }
            } else {
                if (!this.store.getters.contactlessMode && token === 'store' || !this.store.getters.contactlessMode && token === 'guard') {
                    await this.store.dispatch(DISABLE_OVERLAY)
                }
            }

            if (this.responseConfig.whiteLabel) {
                await this.store.commit(SET_WHITE_LABEL, this.responseConfig.whiteLabel);
            }

            this.store.commit(SET_SHOP_MODE, this.responseConfig.mode);
        }

        function iOSversion() {
            if (/iP(hone|od|ad)/.test(navigator.platform)) {
                // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
                const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
            }
            return null
        }

        let ver = iOSversion();
        this.store.commit(SET_CHECK_IOS, ver)

        this.initAxios();
    },

    style(mode = null) {
        mode = mode ? mode : this.WEBVIEW_MODE
        const style = require(`./assets/css/${this.css_direction}_${mode.toLowerCase()}.css`)
        return style
    },

    setMode(mode) {
        this.WEBVIEW_MODE = mode
    },

    setOutlet(val) {
        this.outlet = val
    },

    setResponseConfig(val) {
        this.responseConfig = val
        if (val.css_direction) {
            this.css_direction = val.css_direction
        }
        if (val.check_iiko) {
            this.check_iiko = val.check_iiko
        }
        if (val.outlet) {
            this.outlet = val.outlet
        }
        if (val.outlet_id && val.outlets && val.outlets.length > 0) {
            let outlet = val.outlets.find(x => x.id === val.outlet_id)
            if (outlet) {
                this.outlet = outlet
            }
        }
    }
}